import { __rest } from '../_virtual/_tslib.js';
import React from 'react';
import { DayPickerProvider } from './DayPicker/DayPickerProvider.js';
import { FocusProvider } from './Focus/FocusContext.js';
import { NavigationProvider } from './Navigation/NavigationContext.js';
import { SelectMultipleProvider } from './SelectMultiple/SelectMultipleContext.js';
import { SelectRangeProvider } from './SelectRange/SelectRangeContext.js';
import { SelectSingleProvider } from './SelectSingle/SelectSingleContext.js';

/** Provide the value for all the context providers. */
function RootProvider(props) {
    var children = props.children, initialProps = __rest(props, ["children"]);
    return (React.createElement(DayPickerProvider, { initialProps: initialProps },
        React.createElement(NavigationProvider, null,
            React.createElement(SelectSingleProvider, { initialProps: initialProps },
                React.createElement(SelectMultipleProvider, { initialProps: initialProps },
                    React.createElement(SelectRangeProvider, { initialProps: initialProps },
                        React.createElement(FocusProvider, null, children)))))));
}

export { RootProvider };
//# sourceMappingURL=RootProvider.js.map
